import React from 'react';
import { Card, Col, Empty, Grid, Image, Row, Space, Typography } from 'antd';
import { PictureOutlined } from '@ant-design/icons';

const { Text } = Typography;
const { useBreakpoint } = Grid;

const DeviceImagesCard = ({ images }) => {
  const screens = useBreakpoint();
  const isMobile = !screens.sm;
  const displayImages = (images || []).filter(Boolean);

  return (
    <Card
      title={
        <Space>
          <PictureOutlined style={{ color: '#1890ff' }} />
          <Text strong style={{ fontSize: isMobile ? '14px' : '16px' }}>Device Images ({displayImages.length})</Text>
        </Space>
      }
      variant="borderless"
      style={{ borderRadius: '12px', border: '1px solid #f0f0f0', boxShadow: '0 1px 4px rgba(0,0,0,0.02)' }}
      styles={{
        header: { borderBottom: '1px solid #f0f0f0', padding: isMobile ? '12px 14px' : '16px 24px' },
        body: { padding: isMobile ? '14px' : '24px' },
      }}
    >
      {displayImages.length > 0 ? (
        <Image.PreviewGroup>
          <Row gutter={[10, 10]}>
            {displayImages.map((img, index) => (
              <Col xs={8} sm={8} md={8} lg={8} xl={8} key={img || index}>
                <div style={{ aspectRatio: '1/1', width: '100%', overflow: 'hidden', borderRadius: '6px', border: '1px solid #f0f0f0' }}>
                  <Image
                    width="100%"
                    height="100%"
                    src={img}
                    style={{ objectFit: 'cover', transition: 'transform 0.3s ease' }}
                    className="device-preview-img"
                  />
                </div>
              </Col>
            ))}
          </Row>
        </Image.PreviewGroup>
      ) : (
        <Empty description="No device images available" image={Empty.PRESENTED_IMAGE_SIMPLE} />
      )}
    </Card>
  );
};

export default DeviceImagesCard;
